function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42 5H5V42C5 62.4345 21.5655 79 42 79H79V42C79 21.5655 62.4345 5 42 5ZM0 0V42C0 65.196 18.804 84 42 84H84V42C84 18.804 65.196 0 42 0H0ZM42 65C54.7025 65 65 54.7025 65 42C65 29.2975 54.7025 19 42 19C29.2975 19 19 29.2975 19 42C19 54.7025 29.2975 65 42 65ZM42 70C57.464 70 70 57.464 70 42C70 26.536 57.464 14 42 14C26.536 14 14 26.536 14 42C14 57.464 26.536 70 42 70ZM49 42C49 45.866 45.866 49 42 49C38.134 49 35 45.866 35 42C35 38.134 38.134 35 42 35C45.866 35 49 38.134 49 42ZM54 42C54 48.6274 48.6274 54 42 54C35.3726 54 30 48.6274 30 42C30 35.3726 35.3726 30 42 30C48.6274 30 54 35.3726 54 42Z",
  fill: "#09BAD3"
});

var SvgExperienceIc = function SvgExperienceIc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExperienceIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/experience_ic.907bc49e.svg";
export { ForwardRef as ReactComponent };